import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

/** DEMO-ONLY: Microsoft SSO identity for click-to-pick on Sign-in. */
export interface PresidioDemoSsoIdentity {
  id: string;
  labelKey: string;
  outcomeKey: string;
  fillAriaKey: string;
  /** Verified Microsoft email from IdP (demo). */
  email: string;
  /** When false, Azure succeeds but MyPresidio has no matching user. */
  hasAccount: boolean;
}

/**
 * DEMO-ONLY: SSO outcomes for FR 1.2.5 validation.
 * Must stay aligned with isPresidioMockEmailAlreadyRegistered() registered logins.
 */
export const PRESIDIO_DEMO_SSO_IDENTITIES: readonly PresidioDemoSsoIdentity[] = [
  {
    id: 'has_account',
    labelKey: 'account.login.sso.microsoft.demo.has_account',
    outcomeKey: 'account.login.sso.microsoft.demo.has_account.outcome',
    fillAriaKey: 'account.login.sso.microsoft.demo.has_account.aria',
    email: 'jordan.hale@acme.com',
    hasAccount: true,
  },
  {
    id: 'no_account',
    labelKey: 'account.login.sso.microsoft.demo.no_account',
    outcomeKey: 'account.login.sso.microsoft.demo.no_account.outcome',
    fillAriaKey: 'account.login.sso.microsoft.demo.no_account.aria',
    email: 'sso.newhire@contoso.com',
    hasAccount: false,
  },
];

/**
 * DEMO-ONLY — pick a mocked Microsoft identity after Continue with Microsoft.
 */
@Component({
  selector: 'ish-demo-sso-modal',
  templateUrl: './demo-sso-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DemoSsoModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  readonly identities = PRESIDIO_DEMO_SSO_IDENTITIES;

  select(identity: PresidioDemoSsoIdentity): void {
    this.activeModal.close(identity);
  }

  hide(): void {
    this.activeModal.dismiss();
  }
}
